import cn from "@/v2-ui/utils/utils.cn"
import { errorToast } from "@/v2-ui/toast"
import Page, { type PageProps } from "@/v2-backoffice-client/components/page"
import TenantTable from "@/v2-backoffice-client/tenant/TenantTable"
import TenantCreateButton from "@/v2-backoffice-client/tenant/create/TenantCreateButton"
import { useTenantCountsQuery } from "@/v2-backoffice-client/tenant/counts/tenant.counts.query"

export type TenantPageProps = PageProps

function TenantPage(props: TenantPageProps) {
  const { className, ...pageProps } = props

  const { data, loading, error } = useTenantCountsQuery()
  const activeCount = data?.getTenantCounts.active
  const deletedCount = data?.getTenantCounts.deleted

  errorToast(error, {
    title: "Failed to query for team counts",
  })

  return (
    <Page className={cn("tenant-page", className)} {...pageProps}>
      <Page.Header>
        <Page.Title>Teams</Page.Title>
        <Page.Header.Actions>
          <TenantCreateButton />
        </Page.Header.Actions>
      </Page.Header>

      <Page.Content className="flex-1 min-h-0 overflow-auto">
        <TenantTable
          isLoading={loading}
          activeCount={activeCount}
          removedCount={deletedCount}
        />
      </Page.Content>
    </Page>
  )
}

export default TenantPage
